import { useQueryClient } from '@tanstack/react-query';

import {
  getApiV1ExamCorrectionGridExampublishidQueryKey,
  usePostApiV1ExamCorrectExam,
} from '@/shared/api/generated';

// ─── Hook ─────────────────────────────────────────────────────────────────────

/**
 * Hook para submeter a correção de uma resposta.
 *
 * Invalida automaticamente o cache do grid de correções do exame após sucesso,
 * garantindo que a listagem reflita o novo estado sem reload manual.
 *
 * @param examPublishId - ID da publicação do exame para invalidar o cache após sucesso
 * @returns Mutation para submeter correção com estado de loading/error
 *
 * @example
 * ```tsx
 * const { mutate: submit, isPending } = useSubmitCorrection(examPublishId);
 * submit({ data: { answerId, completness, comment } });
 * ```
 */
export function useSubmitCorrection(examPublishId: number | null) {
  const queryClient = useQueryClient();

  return usePostApiV1ExamCorrectExam({
    mutation: {
      onSuccess: () => {
        if (examPublishId !== null) {
          void queryClient.resetQueries({
            queryKey: getApiV1ExamCorrectionGridExampublishidQueryKey(examPublishId),
          });
        }
      },
    },
  });
}
